var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"refresh",on:{"click":function($event){return _vm.refreshClicked()}}},[_vm._v("An update is available. "),_c('span',[_vm._v("Reload Tueday")])])}
var staticRenderFns = []

export { render, staticRenderFns }